import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["icon", "children", "background", "color", "borderColor", "borderStyle", "borderWidth"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import * as React from 'react';
import { clsx as cx } from 'clsx';
import * as styles from './styles.module.css';
import { getColorProps, getBackgroundProps, getBorderProps } from './helpers';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var DEFAULT_COLOR = 'white_100';
var DEFAULT_BACKGROUND = 'gray60_100';
export var Label = /*#__PURE__*/React.forwardRef(function Label(_ref, ref) {
  var icon = _ref.icon,
    children = _ref.children,
    background = _ref.background,
    color = _ref.color,
    borderColor = _ref.borderColor,
    borderStyle = _ref.borderStyle,
    borderWidth = _ref.borderWidth,
    htmlProps = _objectWithoutProperties(_ref, _excluded);
  var isPointer = !!htmlProps.onClick;
  var colorProps = getColorProps(color || DEFAULT_COLOR);
  var backgroundProps = getBackgroundProps(background || DEFAULT_BACKGROUND);
  var borderProps = getBorderProps({
    borderColor: borderColor,
    borderStyle: borderStyle,
    borderWidth: borderWidth
  });
  return /*#__PURE__*/_jsxs("span", _objectSpread(_objectSpread({}, htmlProps), {}, {
    ref: ref,
    className: cx(styles['label'], isPointer && styles['cursor_pointer'], colorProps.className, backgroundProps.className, borderProps.className),
    style: _objectSpread(_objectSpread(_objectSpread({}, colorProps.style), backgroundProps.style), borderProps.style),
    children: [icon, children && /*#__PURE__*/_jsx("span", {
      children: children
    })]
  }));
});
Label.defaultProps = {
  color: DEFAULT_COLOR,
  background: DEFAULT_BACKGROUND
};